import "neuroglancer/datasource/brainmaps/frontend";
import "neuroglancer/datasource/brainmaps/register_credentials_provider";
import "neuroglancer/datasource/brainmaps/register_default";
import "neuroglancer/datasource/boss/frontend";
import "neuroglancer/datasource/boss/register_credentials_provider";
import "neuroglancer/datasource/boss/register_default";
import "neuroglancer/datasource/dvid/frontend";
import "neuroglancer/datasource/dvid/register_credentials_provider";
import "neuroglancer/datasource/dvid/register_default";
import "neuroglancer/datasource/render/frontend";
import "neuroglancer/datasource/render/register_default";
import "neuroglancer/datasource/precomputed/frontend";
import "neuroglancer/datasource/precomputed/register_default";
import "neuroglancer/datasource/nifti/frontend";
import "neuroglancer/datasource/nifti/register_default";
import "neuroglancer/datasource/n5/frontend";
import "neuroglancer/datasource/n5/register_default";
import "neuroglancer/datasource/zarr/frontend";
import "neuroglancer/datasource/zarr/register_default";
import "neuroglancer/datasource/vtk/frontend";
import "neuroglancer/datasource/vtk/register_default";
import "neuroglancer/datasource/obj/frontend";
import "neuroglancer/datasource/obj/register_default";
import "neuroglancer/datasource/ngauth/register_credentials_provider";
import "neuroglancer/datasource/middleauth/register_credentials_provider";
import "neuroglancer/datasource/nggraph/frontend";
import "neuroglancer/datasource/nggraph/register_default";
import "neuroglancer/image_user_layer";
import "neuroglancer/segmentation_user_layer";
import "neuroglancer/single_mesh_user_layer";
import "neuroglancer/annotation/user_layer";
import "../../../../src/main.ts";
